/**
 * Coach feedback form intro paragraphs (MED-330)
 * Adapted from the Paperform sentiment per AC13
 */
export const COACH_FEEDBACK_INTRO: Record<'midpoint' | 'endpoint', string> = {
  midpoint:
    'Thank you for taking a few minutes to share your experience coaching this cohort. Your feedback helps us make adjustments for the remainder of the program and highlight successes.',
  endpoint:
    'Thank you for sharing your overall assessment of coaching this cohort. Your feedback helps us improve future programs and demonstrate the impact of coaching.',
};
